export default "__VITE_ASSET__CrXocY0u__"